import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { developersCacheKey } from "./constants";
import type { Developer, GetDevelopersQueryParams } from "./types";

type GetDevelopersArgs = [companyId: string] | [companyId: string, queryParams: GetDevelopersQueryParams];

/**
 * Get the latest developer information.
 */
export const getDevelopers = reactQueryFetcherAdapter<
  typeof developersCacheKey,
  readonly [rootKey: RootCacheKey<typeof developersCacheKey>, ...originalKey: GetDevelopersArgs],
  GetDevelopersArgs,
  Developer[]
>(
  developersCacheKey,
  async (signal: AbortSignal, ...[companyId, queryParams]: GetDevelopersArgs): Promise<Developer[]> => {
    return fetch(`/companies/${companyId}/developers`, "GET", queryParams, { signal });
  }
);
